




import { Vue, Component, Prop } from "@/shared/vuepack";

@Component({})
export default class Metric extends Vue {
  @Prop({ required: true }) metricName;
  @Prop({ required: true }) height;
  @Prop({ required: true }) width;
  @Prop({ default: null }) accessToken;
  @Prop({ default: null }) employerCode;
  @Prop({ required: true }) tableauUrl;

  metricHtml = "";

  async mounted () {
    await this.renderMetricCard();
  }

  async renderMetricCard () {
    this.metricHtml = `
       <tableau-viz id='tableau-viz'
            style='display:none;'
            src='${this.tableauUrl}/user/tableau/views/${this.metricName}'
            width='${this.width}'
            height='${this.height}'
            toolbar='hidden'
            device='desktop'
            hide-tabs>
            <viz-filter field='token' value='${await this.accessToken}'> </viz-filter>
            <viz-filter field='Employer Code' value='${this.employerCode}'> </viz-filter>
        </tableau-viz>
    `;
    window.postMessage("loadtableauview");
  }
}
